import type { QuoteDocument, UrlViewType } from 'paintscout'
import { setStatus } from '../../status'
import { setDates } from '../../dates'

export function acceptQuote(args: {
  quote: QuoteDocument
  signature?: string
  view: UrlViewType
  acceptedVia?: 'onTheSpot' | 'editQuoteInfo' | 'customer' | ''
}) {
  const { signature, view, acceptedVia } = args
  let quote = args.quote
  const ignoreStatuses = ['accepted', 'invoiced', 'paid', 'partial']

  if (ignoreStatuses.indexOf(quote.status.value) === -1) {
    quote = setStatus({ quote, status: 'accepted', acceptedVia })
  }

  quote.sendError = null

  if (signature) {
    if (!quote.signatures) {
      quote.signatures = {}
    }

    if (view === 'quote') {
      quote.signatures.customer = signature
    }
  }

  const now = Date.now()
  if (view === 'quote') {
    quote = setDates({ quote, client: { accepted: now }, updated: now })
  } else if (view === 'work-order') {
    quote = setDates({ quote, staff: { accepted: now }, updated: now })
  }

  return quote
}
